import React from 'react';

import MainLayout from '@/layout/MainLayout';
import Login from '@/pages/auth/Login';
import Sales from '@/pages/sales/Sales';

const SalesTicket = React.lazy(() => import('@/pages/sales/SalesTicket'));
const PayScreen = React.lazy(() => import('@/pages/sales/PayScreen'));
const SalesBacklog = React.lazy(() => import('@/pages/sales/SalesBacklog'));
const SalesOpenInvoices = React.lazy(() => import('@/pages/sales/SalesOpenInvoices'));
const notFound = React.lazy(() => import('@/pages/NotFound'));
const listCategories = React.lazy(() => import('@/pages/categories/ListCategories'));
const listDiscounts = React.lazy(() => import('@/pages/discounts/ListDiscounts'));
const listModifiers = React.lazy(() => import('@/pages/modifiers/ListModifiers'));
const Receipts = React.lazy(() => import('@/pages/sales/Receipts'));
const Receipt = React.lazy(() => import('@/pages/sales/Receipt'));
const Refund = React.lazy(() => import('@/pages/sales/Refund'));
const ListItems = React.lazy(() => import('@/pages/items/ListItems'));
const Shift = React.lazy(() => import('@/pages/shift/Shift'));
const CloseShift = React.lazy(() => import('@/pages/shift/CloseShift'));
const CashManagement = React.lazy(() => import('@/pages/shift/CashManagement'));
const ShiftAnalytics = React.lazy(() => import('@/pages/shift/ShiftAnalytics'));
const Settings = React.lazy(() => import('@/pages/Settings'));
const KDS = React.lazy(() => import('@/pages/sales/KDS'));

const routes = [
  {
    path: '/login',
    Component: Login,
  },
  {
    path: '/',
    Component: MainLayout,
    children: [
      {
        index: true,
        Component: Sales,
      },
      {
        path: '/ticket/:ID',
        Component: SalesTicket,
      },
      {
        path: '/pay/:ID',
        Component: PayScreen,
      },
      {
        path: '/backlog',
        Component: SalesBacklog,
      },
      {
        path: '/open-invoices',
        Component: SalesOpenInvoices,
      },
      {
        path: '/kds',
        Component: KDS,
      },
      {
        path: '/receipts',
        Component: Receipts,
      },
      {
        path: '/receipts/:id',
        Component: Receipt,
      },
      {
        path: '/refund/:id',
        Component: Refund,
      },
      {
        path: '/items/all',
        Component: ListItems,
      },
      {
        path: '/items/categories',
        Component: listCategories,
      },
      {
        path: '/items/discounts',
        Component: listDiscounts,
      },
      {
        path: '/items/modifiers',
        Component: listModifiers,
      },
      {
        path: '/shift',
        Component: Shift,
      },
      {
        path: '/cash-management',
        Component: CashManagement,
      },
      {
        path: '/close-shift',
        Component: CloseShift,
      },
      {
        path: '/shift-analytics/:shiftId?',
        Component: ShiftAnalytics,
      },
      {
        path: '/settings',
        Component: Settings,
      },
      {
        path: '/404',
        Component: notFound,
      },
      {
        path: '*',
        Component: notFound,
      },
    ],
  },
];

export default routes;
